import { formatRupeeLiteral } from '../../constants';

export const AboutFund = ({ amcDetail }) => {
  const AmcDetailsArr = [
    { heading: 'No. of schemes', data: amcDetail.totalSchemes },
    { heading: 'Total AUM', data: '₹' + formatRupeeLiteral(amcDetail.aum) },
    {
      heading: 'Address',
      data: (
        <span>
          {[
            amcDetail.addressLine1
              ? amcDetail.addressLine1.trim().replace(/,\s*$/, '')
              : '',
            amcDetail.addressLine2
              ? amcDetail.addressLine2.trim().replace(/,\s*$/, '')
              : '',
            amcDetail.city ? amcDetail.city.trim().replace(/,\s*$/, '') : '',
            amcDetail.province
              ? amcDetail.province.trim().replace(/,\s*$/, '')
              : '',
            amcDetail.postalCode
              ? amcDetail.postalCode.trim().replace(/,\s*$/, '')
              : '',
          ]
            .filter((line: string) => line.length > 0)
            .join(', ')}
        </span>
      ),
    },
    { heading: 'Phone', data: amcDetail.phone },
  ];
  return (
    <div className=" lil-mt-12 sm:lil-mt-2">
      <p className="lil-mb-4 lil-mt-8 lil-font-bold lil-text-font-500 lil-text-s-28 sm:lil-text-s-20 sm:lil-mt-6">
        About {amcDetail.name}
      </p>
      <p className="lil-text-base lil-font-normal">{amcDetail.description}</p>
      {/* <table className="lil-border-grey-300 lil-border-separate lil-border-sm lil-border-spacing-0 lil-mt-5 lil-rounded-xl lil-w-full">
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Managers
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 ">
            {fundManagers.map((ele, i) => (
              <span className="lil-text-font-400 lil-text-s-14 lil-font-medium">
                {ele.name}
                {`${i === fundManagers.length - 1 ? '' : ', '}`}{' '}
              </span>
            ))}
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Custodians
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">
              {amcDetail.custodian}
            </p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Address
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">
              {amcDetail.addressLine1} {amcDetail.addressLine2}
            </p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Fax Nos.
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">{amcDetail.fax}</p>
          </td>
        </tr>
        <tr>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Telephone Nos.
            </p>
          </td>
          <td className="lil-border-b-sm lil-border-grey-300 lil-p-5">
            <p className="lil-text-s-14 lil-text-font-400">{amcDetail.phone}</p>
          </td>
        </tr>
        <tr>
          <td className="lil-p-5 lil-border-grey-300 lil-border-r-sm">
            <p className="lil-text-base lil-text-font-500 lil-font-bold">
              Homepage
            </p>
          </td>
          <td className="lil-p-5">
            <a
              className="lil-text-s-14 lil-btn-link lil-font-medium"
              href={amcDetail.website}
            >
              {amcDetail.website}
            </a>
          </td>
        </tr>
      </table> */}

      <p className="lil-mt-8 lil-text-font-500 lil-text-s-20 sm:lil-text-base">
        {amcDetail.name} Details
      </p>

      <div className="lil-mt-2">
        <div className="lil-rounded-xl lil-bg-white">
          <ul className="lil-w-full">
            {AmcDetailsArr.map((item, index) => (
              <li
                key={index}
                className={`lil-flex lil-justify-between lil-items-center lil-py-3 lil-relative`}
              >
                <span className="lil-font-light lil-text-grey-600">
                  {item.heading}
                </span>
                <span className="lil-font-semibold lil-text-grey-900 lil-text-right lil-w-1/2 lil-text-left">
                  {item.data}
                </span>
                {index !== AmcDetailsArr.length - 1 && (
                  <div className="lil-absolute lil-h-px lil-bg-grey-300 lil-bottom-0 lil-left-0 lil-right-0"></div>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/aboutFund.tsx